export const LOOPS_NEWSLETTER_FORM_ID = "cmobu632t08lp0iviwzjbwli4";
export const LOOPS_NEWSLETTER_FORM_ENDPOINT = `https://app.loops.so/api/newsletter-form/${LOOPS_NEWSLETTER_FORM_ID}`;
export const LOOPS_DEFAULT_USER_GROUP = "ContactForm";
